import React, { FC } from 'react';
import { Flex, IconButton } from '@radix-ui/themes';
import './NavbarLinksList.css';

interface NavbarLinksListProps { }

const NavbarLinksList: FC<NavbarLinksListProps> = () => (
  <Flex gap="4" align="center">
    <IconButton asChild variant="ghost" size="1" style={{ color: "#053b50", cursor: "pointer" }}>
      <a href="mailto:zafir@zfir.dev" target="_blank" rel="noopener noreferrer" aria-label="Email">
        <i className="material-icons" style={{ fontSize: '18px' }}>mail</i>
      </a>
    </IconButton>
    <IconButton asChild variant="ghost" size="1" style={{ color: "#053b50", cursor: "pointer" }}>
      <a href="https://www.linkedin.com/in/zfir/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
        <i className="fab fa-linkedin-in" style={{ fontSize: '18px' }}></i>
      </a>
    </IconButton>
    <IconButton asChild variant="ghost" size="1" style={{ color: "#053b50", cursor: "pointer" }}>
      <a href="https://github.com/zfir/" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
        <i className="fab fa-github" style={{ fontSize: '18px' }}></i>
      </a>
    </IconButton>
    <IconButton asChild variant="ghost" size="1" style={{ color: "#053b50", cursor: "pointer" }}>
      <a href="https://zfir.medium.com/" target="_blank" rel="noopener noreferrer" aria-label="Medium">
        <i className="fab fa-medium" style={{ fontSize: '18px' }}></i>
      </a>
    </IconButton>
    <IconButton asChild variant="ghost" size="1" style={{ color: "#053b50", cursor: "pointer" }}>
      <a href="https://x.com/_zfir_" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
        <i className="fab fa-x-twitter" style={{ fontSize: '18px' }}></i>
      </a>
    </IconButton>
  </Flex>
);

export default NavbarLinksList;
